import { createSlice } from "@reduxjs/toolkit";

const initialState = {

  user: null,

  accessToken: null,

  refreshToken: null,

  apps: [],

  verificationRequired: false,

  verificationId: null,

  otpPurpose: null,

  loading: false,

  error: null
};

const authSlice = createSlice({

  name: "auth",

  initialState,

  reducers: {

    authStart(state) {

      state.loading = true;
      state.error = null;
    },

    authSuccess(
      state,
      action
    ) {

      state.loading = false;

      state.user =
        action.payload.user;

      state.accessToken =
        action.payload.accessToken;

      state.refreshToken =
        action.payload.refreshToken;

      state.apps =
        action.payload.apps || [];

      state.verificationRequired =
        action.payload.verificationRequired || false;
    },

    authFailure(
      state,
      action
    ) {

      state.loading = false;

      state.error =
        action.payload;
    },

    logoutSuccess(state) {

      return initialState;
    },

    setOtpState(
      state,
      action
    ) {

      state.verificationId =
        action.payload.verificationId;

      state.otpPurpose =
        action.payload.purpose;
    },

    clearOtpState(state) {

      state.verificationId = null;

      state.otpPurpose = null;
    }
  }
});

export const {

  authStart,

  authSuccess,

  authFailure,

  logoutSuccess,

  setOtpState,

  clearOtpState

} = authSlice.actions;

export default authSlice.reducer;